import React from 'react';
import { MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
const Footer: React.FC = () => {
  return <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <img src="/lovable-uploads/73ffe428-367d-4acd-b581-fd0081d6e945.png" alt="Fox Vendas" className="h-8 mb-4" />
            <p className="text-gray-300 mb-4 max-w-md">
              Sua imobiliária de confiança. Oferecemos os melhores imóveis com 
              atendimento personalizado e segurança total em todas as transações.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61554834861616" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-orange-500 transition-colors">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="https://www.instagram.com.br/foxvendasimob" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-orange-500 transition-colors">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="https://www.linkedin.com/company/foxvendas" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-orange-500 transition-colors">
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Início
                </a>
              </li>
              <li>
                <a href="/busca" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Buscar Imóveis
                </a>
              </li>
              <li>
                <a href="/quem-somos" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Sobre Nós
                </a>
              </li>
              <li>
                <a href="/trabalhe-conosco" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Trabalhe Conosco
                </a>
              </li>
              <li>
                <a href="/politica-privacidade" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a href="/dashboard" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Admin
                </a>
              </li>
            </ul>
          </div>

          {/* Onde Estamos */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Onde Estamos</h3>
            <div className="space-y-4">
              <div>
                <h4 className="text-orange-500 font-semibold mb-2">Unidade Campinas</h4>
                <div className="flex items-start space-x-2">
                  <MapPin className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                  <div className="text-gray-300">
                    <p>Rua Alecrins, 940, sala 03</p>
                    <p>Cambuí, Campinas - SP</p>
                    <p className="text-sm text-gray-400 mt-1">CRECI 38.672-J</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-300">
            © 2024 Fox Vendas. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;